module.exports = __webpack_public_path__ + "img/Avatar.077f6e86.svg";